<script setup lang="ts">
type Props = { isCheckDeliveryDetails: boolean }
type Emits = { (fn: 'onChangeVisibleBottomContent', value: boolean): void }

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const BUTTON_TITLES = {
  NEXT: 'Далее',
  CHANGE: 'Изменить или выбрать самовывоз',
}

// Заголовок кнопки взависимости от начилия информации о зоне доставки
const paramsForButton = computed(() => {
  return props.isCheckDeliveryDetails
    ? BUTTON_TITLES.NEXT
    : BUTTON_TITLES.CHANGE
})

const onChangeVisibleBottomContent = (value: boolean) => {
  emit('onChangeVisibleBottomContent', value)
}
</script>

<template>
  <div class="address-system-map-actions">
    <the-button
      class="address-system-map-actions__access-address"
      font="md"
      @click="onChangeVisibleBottomContent(true)"
    >
      {{ paramsForButton }}
    </the-button>
  </div>
</template>

<style scoped lang="scss">
.address-system-map-actions {
  display: flex;

  &__access-address {
    width: 100%;
  }
}
</style>
